import React from "react";
import "../styles/Funcionalidades.css";
import { Building, BarChart3, Bot, Users, Database, Settings } from "lucide-react";

const Funcionalidades = () => {
  const features = [
    { icon: <BarChart3 size={28}/>, text: "Dashboards personalizáveis" },
    { icon: <Building size={28}/>, text: "Empreendimentos de todo o Brasil" },
    { icon: <Bot size={28}/>, text: "Inteligência Artificial integrada" },
    { icon: <Users size={28}/>, text: "Gestão de equipes simplificada" },
    { icon: <Database size={28}/>, text: "Integração com bancos de dados" },
    { icon: <Settings size={28}/>, text: "Configurações personalizáveis" },
  ];

  return (
    <section id="funcionalidades" className="funcionalidades">
      <h2 className="titulo-funcionalidades">Funcionalidades do sistema</h2>
      <div className="grid-funcionalidades">
        {features.map((item, index) => (
          <div key={index} className="card-funcionalidade">
            <div className="icon-bolinha">{item.icon}</div>
            <p className="texto-funcionalidade">{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Funcionalidades;
